<template>
  <div class="login">
    <header class="header">
      <div class="top">
        <div class="left">
          <span><img src="../assets/calogo.png" alt="" /></span>
          <div class="pingtai">统一电子认证电子印章管理平台</div>
        </div>
        <div class="right">
          <div class="leval">统一电子认证电子印章管理平台</div>
          <div class="shu">|</div>
          <div class="loginOrRegist" v-if="IS_LOGIN">
            <span class="regist" @click="toRegist">注册</span> /
            <span class="loginmethods" @click="login">登录</span>
          </div>
          <el-dropdown @command="handleCommand" v-else>
            <span class="el-dropdown-link">
              {{
                this.userInfo.LEGAL_PERSON
                  ? this.userInfo.LEGAL_PERSON
                  : userName
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a" @click.native="loginOut"
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </header>
    <main class="main">
      <div id="registmain">
        <div class="children">
          <router-view></router-view>
        </div>
      </div>
    </main>
    <div class="companyInfo">
      <div class="contentUS">
        <div class="topOne">联系我们</div>
        <div class="toptow">
          <i class="iconfont icon-dizhi"></i
          >地址：河南省郑州市明理路平安大道博雅广场4号楼
        </div>
        <div class="toptow">
          <i class="iconfont icon-dianhua"></i>技术支持电话：0371-96596
        </div>
      </div>
      <div class="aboutUs">
        <div class="topOne">相关链接</div>
        <div class="toptow" @click="toCompany">河南省信息化发展有限公司</div>
        <div class="toptow" @click="toPri">河南省政务服务网</div>
      </div>
      <div class="downLoadApp">
        <div class="topOne">APP下载</div>
       <div class="downLoad">
          <div class="topthree">
            <div class="threespan">安卓</div>
              <el-image
                  style="width: 65px; height: 65px"
                  :src="url"
                  :preview-src-list="srcList"
                >
                </el-image>
          </div>
          <!-- <div style="width: 100%; text-align: center">敬请期待</div> -->
        </div>
      </div>
    </div>
    <footer class="fotter">
      版权所有：河南省信息化发展有限公司
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
     <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">备案：豫ICP备14012421号-6</a>  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <!-- 版权所有：河南省信息化发展有限公司 -->
    </footer>
  </div>
</template>

<script>
export default {
  name: "Regist",
  data() {
    return {
      msg: "",
      activeName: "first",
      IS_LOGIN: true,
      userName: "",
      form: {},
      getVer: false,
      infomation: "注册",
      userInfo: "",
      rules: {},
       userInfo: "",
      url: require("../assets/app.jpg"),
      srcList: [require("../assets/app.jpg")],
    };
  },
  methods: {
    handleCommand() {},
    //切换页码
    handleClick(tab, event) {
      console.log(tab, event);
    },
    //账号密码登录
    changeVerification() {
      this.getVer = false;
    },
    //登录
    login() {
      this.$router.push("/login");
    },
    //xinxihua
    toCompany() {
      window.opene("https://www.hnxaca.com/");
    },
    //zhengwu
    toPri() {
      window.open(" https://www.hnzwfw.gov.cn/");
    },
    //注册
    toRegist() {
      this.$router.push("/regist");
    },
    //登录
    toLogin() {
      this.$router.push("/login");
    },
    //退出登录
    loginOut() {
      this.$http.post("/login/logOut.shtml").then((res) => {
        if (res.data.code == 0) {
          sessionStorage.clear();
          this.$router.push("/main");
          this.$message.success("退出登录成功");
          this.IS_LOGIN = true;
          window.location.reload();
        } else {
          this.$router.push("/login");
        }
      });
    },
    //切换图标
    changeIcon() {},
  },

  created() {},
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (!sessionStorage.getItem("userName")) {
      this.IS_LOGIN = true;
      this.applySealed = false;
    } else {
      this.userName = sessionStorage.getItem("userName");
      this.IS_LOGIN = false;
      this.applySealed = true;
    }
    if (sessionStorage.getItem("userName")) {
      this.IS_LOGIN = false;
      this.userName = sessionStorage.getItem("userName");
    } else {
      this.IS_LOGIN = true;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {  
  margin: 0;
  padding: 0;
  background-color: #ffffff;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.header {
  height: 0.101652%vh;
  background-color: white;
}
.top {
  width: 1110px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.left {
  font-family: MicrosoftYaHei-Bold;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #333333;
  display: flex;
}
.pingtai {
  margin-left: 8px;
  line-height: 108px;
}
.right {
  display: flex;
  font-size: 18px;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #666666;
}
.regist {
  cursor: pointer;
  color: #2850a0;
  font-weight: 800;
}
.loginmethods {
  cursor: pointer;
}
.shu {
  height: 18px;
  width: 1px;
  color: #666666;
  padding: 0 20px;
}
span > img {
  height: 70px;
  width: 94px;
  margin-top: 25px;
}
.main {
  color: #333;
  /* flex: 1; */
  height: 67vh;
  width: 100%;
}
#registmain {
  background-image: url("../assets/regist.png");
  background-repeat: no-repeat center center;
  border: none;
  background-size: cover;
  height: 210px;
}
.registmain {
  width: 1110px;
  margin: 0 auto;
  height: 180px;
}
.info {
  display: flex;
  align-items: center;
  padding-top: 38px;
  width: 200px;
  margin: auto;
}
.icon {
  font-size: 55px;
  color: #ffffff;
}
.mation {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
}
.children {
  width: 1110px;
  margin: 0 auto;
  height: 400px;
  /* background-color: #ffffff; */
}
#mainbg {
  background-image: url("../assets/bg.png");
  background-repeat: no-repeat center center;
  border: none;
  background-size: cover;
  height: 637px;
}
.mainbg {
  margin: 0 auto;
  width: 1110px;
  height: 637px;
  background-image: url("../assets/bg.png");
  overflow: hidden;
}
.el-header {
  height: 0.101652%vh;
  background-color: #ffffff;
}
.loginInfo {
  width: 550px;
  height: 420px;
  background-color: #ffffff;
  box-shadow: 0px 7px 27px 0px rgba(133, 169, 231, 0.51);
  border-radius: 6px;
  margin-bottom: 185px;
  margin-top: 85px;
}
.el-tabs {
  width: 420px;
  height: 351px;
  margin-left: 65px;
  padding-top: 38px;
}
.fotter {
  height: 36px;
  background-color: #cccccc;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
  line-height: 36px;
  width: 100%;
  position: fixed;
  bottom: 0;
}
.el-tabs >>> .el-tabs__content {
  padding-top: 28px;
}
.el-input--prefix >>> .el-input__inner {
  padding-left: 30px;
  height: 48px;
  border: none;
  border-bottom: 1px solid #cccccc;
}
.el-input__inner {
  height: 48px;
  border: none;
  border-bottom: 1px solid #cccccc;
}
.el-tab-pane {
  margin-bottom: 33px;
  height: 160px;
}
.yanzhengma {
  display: flex;
  justify-content: space-between;
  margin-top: 27px;
}
.mima {
  margin-top: 27px;
}
.loginButton {
  margin-bottom: 21px;
}
.freeRegist {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #666666;
  padding-top: 21px;
  margin-left: 320px;
  cursor: pointer;
}
.companyInfo {
  display: flex;
  justify-content: space-between;
  width: 1110px;
  margin: 0 auto;
  margin-bottom: 48px;
}
.contentUS {
  width: 400px;
  height: 110px;
  background-color: #f5f5f5;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}
.aboutUs {
  width: 368px;
  height: 110px;
  background-color: #f5f5f5;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}
.downLoadApp {
  width: 296px;
  height: 110px;
  background-color: #f5f5f5;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}
.downLoad {
  display: flex;
}
.topOne {
  margin: 10px 0px 14px 10px;
}
.toptow {
  margin: 10px 0px 16px 10px;
  height: 22px;
}
.topthree {
  display: flex;
  width: 113px;
  overflow: hidden;
  margin: auto 65px;
}
.threespan {
  margin: 32px 8px 0px 0px;
}
.toptow {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/regist/index.vue